import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section id="cta" className="bg-white py-20 md:py-28">
      <div className="mx-auto max-w-6xl px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-green-800 via-green-700 to-emerald-900 px-8 py-16 text-center shadow-2xl sm:px-16"
        >
          <div className="absolute -left-20 -top-20 h-64 w-64 rounded-full bg-green-500/20 blur-3xl" />
          <div className="absolute -bottom-24 -right-24 h-72 w-72 rounded-full bg-emerald-300/20 blur-3xl" />

          <div className="relative z-10">
            <h2 className="text-3xl font-extrabold text-white sm:text-4xl">
              Ready to bring your FPO online?
            </h2>
            <p className="mx-auto mt-4 max-w-xl text-base text-green-100/85">
              Onboarding takes about 10 minutes. Add your farmers, list your first crop, and start
              receiving orders this week.
            </p>
            <div className="mt-8 flex flex-col items-stretch justify-center gap-3 sm:flex-row">
              <Link
                to="/signup"
                className="inline-flex items-center justify-center gap-2 rounded-xl bg-white px-7 py-3.5 text-base font-semibold text-green-900 transition-all hover:-translate-y-0.5 hover:bg-green-50"
              >
                Get started — free
                <svg className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M9 5l7 7-7 7" />
                </svg>
              </Link>
              <a
                href="mailto:hello@atharva.org"
                className="inline-flex items-center justify-center gap-2 rounded-xl border border-white/40 px-7 py-3.5 text-base font-semibold text-white transition-all hover:-translate-y-0.5 hover:bg-white/10"
              >
                Talk to the team
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
